import { render, staticRenderFns } from "./FileSignatureSelector.vue?vue&type=template&id=4dee190b&scoped=true&"
import script from "./FileSignatureSelector.vue?vue&type=script&lang=js&"
export * from "./FileSignatureSelector.vue?vue&type=script&lang=js&"
import style0 from "./FileSignatureSelector.vue?vue&type=style&index=0&id=4dee190b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee190b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dee190b')) {
      api.createRecord('4dee190b', component.options)
    } else {
      api.reload('4dee190b', component.options)
    }
    module.hot.accept("./FileSignatureSelector.vue?vue&type=template&id=4dee190b&scoped=true&", function () {
      api.rerender('4dee190b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/usuario/components/sign/simple/febos/FileSignatureSelector.vue"
export default component.exports